import api from 'utils/axios';

export const GP_PRIVACY_POLICY = 'GP_PRIVACY_POLICY';

export function getGuestPortalPrivacyPolicy({ signal, queryKey }) {
  const gpId = queryKey[1];

  return api.get(`/guest_portals/${gpId}/privacy_policy`, { signal }).then(({ data }) => data);
}

export function getTourRequestPrivacyPolicy({ signal, queryKey }) {
  const trId = queryKey[1];

  return api.get(`/tour_requests/${trId}/privacy_policy`, { signal }).then(({ data }) => data);
}
